import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import './i18n';

import FontIconStyle from './styles/fontIconStyle';
import GlobalStyle from './styles/global';
import { Toast } from './ui/Toast';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import { theme } from './theme';

type ThemeType = typeof theme;

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register(
      process.env.NODE_ENV === 'production'
        ? '/../firebase-messaging-sw-production.js'
        : '/../firebase-messaging-sw-development.js',
    )

    .then()
    .catch(function (err) {
      console.log('Service worker registration failed, error:', err);
    });
}
const app = (
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <Toast />
      <BrowserRouter>
        <GlobalStyle />
        <FontIconStyle />
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </Provider>
);
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(app);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
export type { ThemeType };
